import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.9062 12.1328C15.6677 12.1328 17.9062 9.89424 17.9062 7.13281C17.9062 4.37139 15.6677 2.13281 12.9062 2.13281C10.1448 2.13281 7.90625 4.37139 7.90625 7.13281C7.90625 9.89424 10.1448 12.1328 12.9062 12.1328Z",
      stroke: "#606269",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.31641 22.1328C4.31641 18.2628 8.1664 15.1328 12.9064 15.1328C13.8664 15.1328 14.7964 15.2628 15.6664 15.5028",
      stroke: "#606269",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22.1409 19.0957H17.6709",
      stroke: "#606269",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19.9062 16.9062V21.3912",
      stroke: "#606269",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }